<template>
  <notifications classes="vue-notification2 text-sm mb-3 mr-2" animation-type="velocity" />
</template>
<style>
.vue-notification-group {
  margin-top: 100px;
}

.vue-notification2 {
  padding: 10px;
  color: #ffffff;

  background: theme("colors.slate.600") !important;
  border-left: 5px solid theme("colors.secondary.400");
  box-shadow: 10px theme("colors.secondary.100");

  &.success {
    background: #68cd86;
    border-left-color: #42a85f;
  }

  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  .notification-title {
    margin-bottom: 10px;
  }
}
</style>
